import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Document, Id, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  hasRetrievedElementAttachments: boolean;
  attachments: Identifiable<Document>[];
  retrieveElementAttachments(
    request: Boundaries["retrieveElementAttachments"]["request"],
  ): void;
}

function useElementAttachmentsRetrieval(elementId: Id): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveElementAttachmentsPending(elementId),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveElementAttachmentsSuccess(elementId),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveElementAttachmentsFailure(elementId),
    ),
    hasRetrievedElementAttachments: useSelector(() =>
      selector.hasRetrievedElementAttachments(elementId),
    ),
    attachments: useSelector(() => selector.getAttachments(elementId)),
    retrieveElementAttachments: core.retrieveElementAttachments,
  };
}

export { useElementAttachmentsRetrieval };
